import { inheritsLoose as _inheritsLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { scaleBand } from 'd3-scale';
import { range } from 'd3-array';
import { Bar } from './Bar.js';

// eslint-disable-next-line zillow/react/prefer-stateless-function
var DataSeries = /*#__PURE__*/function (_Component) {
  function DataSeries() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DataSeries, _Component);
  var _proto = DataSeries.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      data = _this$props.data,
      height = _this$props.height,
      padding = _this$props.padding,
      xScale = _this$props.xScale;
    var yScale = scaleBand().domain(range(data.length)).range([0, height]).paddingInner(padding);
    return /*#__PURE__*/React.createElement("g", null, data.map(function (point, idx) {
      return /*#__PURE__*/React.createElement(Bar, {
        label: point.label,
        height: yScale.bandwidth(),
        width: Math.abs(xScale(0) - xScale(point.value)),
        x: 1,
        y: yScale(idx),
        fill: point.color
        // eslint-disable-next-line zillow/react/no-array-index-key
        ,
        key: idx
      });
    }));
  };
  return DataSeries;
}(Component);
DataSeries.defaultProps = {
  padding: 0.1
};
DataSeries.propTypes = process.env.NODE_ENV !== "production" ? {
  // eslint-disable-next-line zillow/react/forbid-prop-types
  data: PropTypes.array,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  width: PropTypes.number,
  height: PropTypes.number,
  // eslint-disable-next-line zillow/react/no-unused-prop-types
  offset: PropTypes.number,
  padding: PropTypes.number,
  xScale: PropTypes.func
} : {};

export { DataSeries as default };
